export default "__VITE_ASSET__BZrZlEix__"